import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "c-mini-banner__inner" }
const _hoisted_2 = { class: "c-mini-banner__content" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "c-mini-banner__description"
}
const _hoisted_5 = {
  key: 0,
  class: "c-mini-banner__action"
}

import { computed } from 'vue';
import type { MiniBannerProps } from '@/types/components/MiniBanner';
import type { SiteButtonFields } from '@/types/elements/site-button';
import OverallSettings from '@/sections/overall-settings.vue';
import utils from '@/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'MiniBanner',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;
const fields = computed(() => props.fields);

const rootStyle = computed(() => utils.overall?.baseComStyle?.(fields.value) || {});
const title = computed(() => fields.value?.title?.value || '');
const description = computed(() => fields.value?.description?.value || '');

const buttonFields = computed<SiteButtonFields | null>(() => {
  const link = fields.value?.buttonLink?.value;
  const text = fields.value?.buttonText?.value || link?.text || '';
  if (!text && !link?.href) return null;

  return {
    text: { value: text },
    link: {
      value: {
        href: link?.href || '#',
        text,
        target: link?.target || '_self',
      },
    },
    type: {
      id: 'primary',
      name: 'primary',
      fields: {
        phrase: {
          value: 'primary',
        },
      },
    },
    theme: {
      id: 'green',
      name: 'green',
      fields: {
        phrase: {
          value: 'green',
        },
      },
    },
  };
});

return (_ctx: any,_cache: any) => {
  const _component_SiteButton = _resolveComponent("SiteButton")!
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (_openBlock(), _createBlock(OverallSettings, _normalizeProps(_guardReactiveProps(_ctx.$props)), {
    default: _withCtx(() => [
      (fields.value)
        ? (_openBlock(), _createElementBlock("section", {
            key: 0,
            class: "c-mini-banner",
            style: _normalizeStyle(rootStyle.value)
          }, [
            _createVNode(_component_ContentGrid, {
              "desktop-default-grid": [1, 22],
              "mobile-default-grid": [1, 14]
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    (title.value)
                      ? (_openBlock(), _createElementBlock("h2", {
                          key: 0,
                          innerHTML: title.value
                        }, null, 8, _hoisted_3))
                      : _createCommentVNode("", true),
                    (description.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(description.value), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (buttonFields.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_SiteButton, { fields: buttonFields.value }, null, 8, ["fields"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ], 4))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}
}

})